const fieldValidation = {
  required: '{{fieldName}} 是必須的',
  maxLength: '最多 {{value}} 个字元',
  pattern: '{{fieldName}} 无效',
};

export default fieldValidation;
